import { trapFocus, returnFocus, removeMiniCartFocus, removeSearchFocus } from "./utils";

$("#minicart-open").on("click", function (e) {
    e.preventDefault();
    window.returnFocusTo = $(this);
    $('body').removeClass("search-shown");
    $('body').toggleClass("minicart-shown");
    $("#minicart-contents").find("a, button").removeAttr("tabindex");
    trapFocus(document.getElementById('minicart'));
});

$('body').on("click", "#minicart-close", function (e) {
    e.preventDefault();
    $('body').removeClass("minicart-shown");
    removeMiniCartFocus();
    returnFocus();
});

$("#search-open").on("click", function (e) {
    e.preventDefault();
    window.returnFocusTo = $(this);
    $('body').removeClass("minicart-shown");
    $('body').addClass("search-shown");
    $("#site-search-input").select();
    $("#search-panel").find("input, button").removeAttr("tabindex");
    trapFocus(document.getElementById('search-panel'), false);
});
$("#search-close").on("click", function (e) {
    e.preventDefault();
    $('body').removeClass("search-shown");
    returnFocus();
    removeSearchFocus();
});
